import React from 'react';
import { TrayArrowDown, Wrench, ChatCenteredText, Code, TreeStructure } from '@phosphor-icons/react';

const ICONS = {
  INPUT: TrayArrowDown,
  TOOL: Wrench,
  PROMPT: ChatCenteredText,
  CODE: Code,
  FLOW: TreeStructure,
};
const ALIASES = { ANALYSE: 'PROMPT', COMBINE: 'CODE' };

export function normaliseStepType(raw) {
  if (typeof raw !== 'string') return null;
  const up = raw.trim().toUpperCase();
  if (ICONS[up]) return up;
  return ALIASES[up] || null;
}

export default function TypeTag({ type, steps }) {
  const kind = normaliseStepType(type);
  const Icon = kind && ICONS[kind];
  if (!Icon) return null;
  const label = kind === 'FLOW' && steps ? `FLOW · ${steps} ${steps === 1 ? 'STEP' : 'STEPS'}` : kind;
  return (
    <span className="inline-flex items-center gap-1 font-sans font-bold text-xs uppercase tracking-wider text-ink">
      <Icon size={14} weight="duotone" aria-hidden="true" />
      <span>{label}</span>
    </span>
  );
}
